import { TFunction } from 'react-i18next';
import { UserStatus } from '../../../models/users.model';

export const getStatusOptions = (t: TFunction) =>
  Object.values(UserStatus).map((value) => ({
    value,
    label: t(`user_statuses_${value.toLowerCase()}`),
  }));
